"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixtureMake = void 0;
var FixtureMake;
(function (FixtureMake) {
    FixtureMake[FixtureMake["Elkay"] = 1] = "Elkay";
    FixtureMake[FixtureMake["Halsey Taylor"] = 2] = "Halsey Taylor";
    FixtureMake[FixtureMake["Oasis"] = 4] = "Oasis";
    FixtureMake[FixtureMake["Other"] = 8] = "Other";
    FixtureMake[FixtureMake["Zurn"] = 16] = "Zurn";
    FixtureMake[FixtureMake["Manitowoc"] = 32] = "Manitowoc";
    FixtureMake[FixtureMake["Haws"] = 64] = "Haws";
    FixtureMake[FixtureMake["American Standard"] = 128] = "American Standard";
    FixtureMake[FixtureMake["Apollo"] = 256] = "Apollo";
    FixtureMake[FixtureMake["Delta"] = 512] = "Delta";
    FixtureMake[FixtureMake["Gemini"] = 1024] = "Gemini";
    FixtureMake[FixtureMake["Kohler"] = 2048] = "Kohler";
    FixtureMake[FixtureMake["Chicago Faucet"] = 4096] = "Chicago Faucet";
    FixtureMake[FixtureMake["T & S Brass"] = 8192] = "T & S Brass";
    FixtureMake[FixtureMake["Speakman"] = 16384] = "Speakman";
    FixtureMake[FixtureMake["Symmons"] = 32768] = "Symmons";
    FixtureMake[FixtureMake["Royal"] = 65536] = "Royal";
    FixtureMake[FixtureMake["Moen"] = 131072] = "Moen";
    FixtureMake[FixtureMake["Lawler"] = 262144] = "Lawler";
    FixtureMake[FixtureMake["Central"] = 524288] = "Central";
    FixtureMake[FixtureMake["Just"] = 1048576] = "Just";
    FixtureMake[FixtureMake["General Electric"] = 2097152] = "General Electric";
    FixtureMake[FixtureMake["Woodford Manufacturing"] = 4194304] = "Woodford Manufacturing";
    FixtureMake[FixtureMake["Whirlpool"] = 8388608] = "Whirlpool";
    FixtureMake[FixtureMake["Peerless"] = 16777216] = "Peerless";
})(FixtureMake = exports.FixtureMake || (exports.FixtureMake = {}));
//# sourceMappingURL=FixtureMake.js.map